import { AlertCircle, AlertTriangle, CheckCircle, Info, X } from 'lucide-react';
import * as React from 'react';
import './transition-alert.scss';

interface TransitionAlertProps {
  open: boolean;
  handleOpenTransitionAlert: () => void;
  message: string;
  severity: 'success' | 'info' | 'warning' | 'error';
  className?: string;
}

const severityIcons = {
  success: CheckCircle,
  info: Info,
  warning: AlertTriangle,
  error: AlertCircle,
};

export default function TransitionAlert(
  props: TransitionAlertProps,
): React.ReactElement {
  const { open, handleOpenTransitionAlert, message, className, severity } =
    props;

  if (!open) return <></>;

  const Icon = severityIcons[severity];

  return (
    <div
      className={`TransitionAlert TransitionAlert--${severity} ${className ?? ''}`}
    >
      <Icon size={16} className="TransitionAlert__Icon" />
      <span className="TransitionAlert__Message">{message}</span>
      <button
        type="button"
        className="TransitionAlert__Close"
        aria-label="close"
        onClick={handleOpenTransitionAlert}
      >
        <X size={14} />
      </button>
    </div>
  );
}
